import ES from './ES';
import EN from './EN';

export default {
  ...ES,
  ...EN,
};
